/* sm-husfelag.js - page controller / kit adapter 'husfelag' for the Húsfélagspakkinn products.
   Uses window.SMHus (sm-husfelag-vel.js) for drawing/production and window.SMMagnListi
   (sm-magn-listi.js) for the per-flat list parser. Same window.SMVelSida.skra(name, A) contract as
   every other adapter in the kit (see postkassi/src/sm-vs-postkassi.js for the fullest example).
   ES5, ASCII only.

   3.0 (02.10.2026, second Claude Design handoff, see HONNUN.md): sign ids and fields follow signs.json
   (ibud / heimilisfang with the handoff defaults, English line on by default), TeX Gyre Heros is loaded
   for the preview from the project's own sm-letur-texgyreheros-*.json (no Google Fonts, no system
   fallback), no font chooser, the sign's four handoff colour schemes are preselected first.

   Scope (built overnight, 2026-10-01, v1): staerd/litur/utlit come from the page's native Shopify
   option radios (read by name, same technique as sm-vs-postkassi.js samstillaAfNativum - no business
   data invented). Sniðmát, texti, flokkur, festing, rammi and the per-flat list are one custom step
   ("stilling") that this file draws itself. Package presets (einn /cart/add.js með N línum) and the
   cart-side "Breyta lista" link are NOT wired in this pass - they touch sections/sm-cart.liquid,
   which needs to be read fresh off the live "Claude update" theme before editing; see README. */
(function () {
  'use strict';
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var SMHus = (typeof window !== 'undefined' && window.SMHus) || (typeof require === 'function' ? require('./sm-husfelag-vel.js') : null);
  var SMMagnListi = (typeof window !== 'undefined' && window.SMMagnListi) || (typeof require === 'function' ? require('./sm-magn-listi.js') : null);

  var CTX = null, GOGN_HLADID = false;
  var ST = { vara: 'bilastaedaskilti', pakki: false, staerd: '190x90', litur: '902', utlit: 'svart', snid: 'einkabilastaedi', linur: ['', ''], logo: false, logoSkra: null, festing: 'got', tappar: 'engir', flokkur: 'MATARLEIFAR', gata: '', ibud: '', listi: false, magnTexti: '', ensku: true };

  /* Logo +1.000 kr (owner 01.10, final: the owner's own request on parking signs, einkastaedi/
     gestastaedi/eigin). Fee product "Lógó á skilti" is a separate UNLISTED Aukagjald product (same
     type as logo-a-gaeludyramerki: untracked inventory, excluded from the bulk discount collection
     rule TYPE != Aukagjald), gid recorded in README.md / TILBUID.md. The sign's own cart line never
     changes price - the fee is its own line, same as every other Aukagjald product in the store. The
     uploaded artwork travels as a file line property on the SIGN's line (adapter skrar() hook, the
     same SMSkra/skrar mechanism the kit already uses for every other file-upload field), never on the
     fee line - the fee product never changes (no options), so it never needs to receive a file. */
  var TAPPAR_VARIANT = '46300565995605', TAPPAR_VERD = 600; /* Tappar á skilti, gid://shopify/Product/8511628640341, 600 kr per plug (owner 08.10, as on the house numbers) */
  var LOGO_GJALD_VARIANT = '46256919543893'; /* Lógó á skilti, gid://shopify/Product/8491718836309 */

  /* Preview fonts: the SAME bytes SMFram engraves with (out/assets/sm-letur-<id>.json, base64 WOFF),
     injected as @font-face data: URLs. TeX Gyre Heros 700/400 for the signs (GUST Font License),
     Barlow Semi Condensed 700 for the bin labels. No Google Fonts, no system fallback. */
  var LETUR_SKRAR = [['TeX Gyre Heros', 700, 'texgyreheros-700'], ['TeX Gyre Heros', 400, 'texgyreheros-400'], ['Barlow Semi Condensed', 700, 'barlowsemicondensed-700']];
  function hladaLetur(J) {
    if (typeof document === 'undefined' || document.getElementById('hf-letur')) return;
    var st = document.createElement('style'); st.id = 'hf-letur'; document.head.appendChild(st);
    LETUR_SKRAR.forEach(function (L) {
      fetch(J('sm-letur-' + L[2] + '.json')).then(function (r) { return r.json(); }).then(function (d) {
        st.appendChild(document.createTextNode('@font-face{font-family:"' + L[0] + '";font-weight:' + L[1] + ';src:url(data:font/woff;base64,' + d.b64 + ') format("woff")}'));
        if (CTX) { CTX.breytt(); if (CTX.flisar) CTX.flisar(); }
      }).catch(function () {});
    });
  }
  var MAGN_EDIT_KEY = null;
  /* "Breyta lista" round trip (aaetlun.md 1.2): the cart link is ?magn=<line key>. On load, read the
     line back from /cart.js (never from the URL itself - the key is just a lookup id, no personal
     data in the query string) and pre-fill the list UI. MAGN_EDIT_KEY is used by the kit's own
     add-to-cart flow is NOT modified here (out of scope tonight, see README): the customer still
     removes the old line by hand after adding the corrected one, same as "Fjarlægja" already does. */
  function hladaBreytaLista() {
    if (typeof window === 'undefined' || !window.fetch) return;
    var m = /[?&]magn=([^&]+)/.exec(window.location.search);
    if (!m) return;
    MAGN_EDIT_KEY = decodeURIComponent(m[1]);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = (cart.items || []).filter(function (it) { return it.key === MAGN_EDIT_KEY; })[0];
      if (!line || !line.properties) return;
      var p = line.properties;
      ST.listi = true;
      ST.gata = p['Gata'] || p['gata'] || '';
      var listi = p['_listi'];
      if (listi) { try { ST.magnTexti = JSON.parse(listi).join(', '); } catch (e) {} }
      if (CTX) CTX.breytt();
    }).catch(function () {});
  }

  function hladaGogn() {
    if (GOGN_HLADID || typeof window === 'undefined' || !window.fetch) return;
    GOGN_HLADID = true;
    /* no asset_url helper available in plain JS - fetch relative to this script's own <script src>, same
       folder. NOT document.currentScript: upphaf() runs while the kit core (sm-vel-sida.js) executes, so
       currentScript was that file and every json URL became "sm-vel-sida.js?v=...sm-husfelag-takn.json"
       (live bug 01.10: serif fallback, no icon). The ?v= of this script is reused as the cache-buster
       (the CDN may serve stale copies without one). */
    var self = document.querySelector('script[src*="sm-husfelag.js"]') || document.currentScript;
    var src = self ? String(self.src) : '';
    var base = src.replace(/sm-husfelag\.js.*$/, '');
    var vm = /[?&]v=([^&]+)/.exec(src), v = vm ? '?v=' + vm[1] : '';
    var J = function (n) { return base + n + v; };
    hladaLetur(J);
    fetch(J('sm-husfelag-takn.json')).then(function (r) { return r.json(); }).then(function (d) { SMHus.setTakn(d); if (CTX) { CTX.breytt(); if (CTX.flisar) CTX.flisar(); } }).catch(function () {});
    fetch(J('sm-fenur.json')).then(function (r) { return r.json(); }).then(function (d) { SMHus.setFenur(d); if (CTX) { CTX.breytt(); if (CTX.flisar) CTX.flisar(); } }).catch(function () {});
    /* real glyph advances + kerning of the production fonts (SMHus measures text with them) */
    fetch(J('sm-husfelag-letur-mal.json')).then(function (r) { return r.json(); }).then(function (d) { SMHus.setLeturMal(d); if (CTX) { CTX.breytt(); if (CTX.flisar) CTX.flisar(); } }).catch(function () {});
    /* register the fonts with SMFram so the production file can be outlined: SMFram fetches the
       sm-letur-<id>.json itself (b64 WOFF) when the first add-to-cart needs it */
    skraLeturIKjarna(J);
  }
  var LETUR_UPPRUNI = {
    'texgyreheros-700': { nafn: 'TeX Gyre Heros', thykkt: 700, uppruni: 'CTAN fonts/tex-gyre/opentype/texgyreheros-bold.otf (GUST Font License)' },
    'texgyreheros-400': { nafn: 'TeX Gyre Heros', thykkt: 400, uppruni: 'CTAN fonts/tex-gyre/opentype/texgyreheros-regular.otf (GUST Font License)' },
    'barlowsemicondensed-700': { nafn: 'Barlow Semi Condensed', thykkt: 700, uppruni: 'google/fonts ofl/barlowsemicondensed static TTF' }
  };
  function skraLeturIKjarna(J) {
    var F = window.SMFram;
    if (!F || !F.skraLetur) { setTimeout(function () { skraLeturIKjarna(J); }, 800); return; }
    Object.keys(LETUR_UPPRUNI).forEach(function (id) {
      var U = LETUR_UPPRUNI[id];
      try { F.skraLetur(id, { url: J('sm-letur-' + id + '.json'), nafn: U.nafn, thykkt: U.thykkt, uppruni: U.uppruni, gf: id.indexOf('barlow') === 0 }); } catch (e) { if (window.console) console.warn('sm-husfelag: skraLetur ' + id + ' ' + (e && e.message)); }
    });
  }
  function V() { return (CTX && CTX.vel) || {}; }
  function ORD() { return V().ord || {}; }
  function t(k, b) { var s = ORD()[k]; s = s == null ? k : String(s); if (b) s = s.replace(/\{(\w+)\}/g, function (m, n) { return b[n] != null ? String(b[n]) : m; }); return s; }
  /* FB 21.10 (D2): words the customer sees come from ui_* (translated in sm-vl-husfelag.liquid); the plain keys stay the Icelandic cart names */
  function u(k, vara) { var s = ORD()['ui_' + k]; return s != null && s !== '' ? String(s) : vara; }

  function checkedNafn(lykill, rot) {
    var el = (rot || document).querySelector('[data-lykill="' + lykill + '"] input:checked');
    return el ? (el.getAttribute('data-nafn') || el.value) : null;
  }
  var STAERD_NAFN = {};
  for (var sk in SMHus.STAERDIR) if (has(SMHus.STAERDIR, sk)) {
    var s = SMHus.STAERDIR[sk];
    STAERD_NAFN[(s.b / 10) + ' x ' + (s.h / 10) + ' cm'] = sk;
  }
  var LITUR_NAFN = {};
  SMHus.LITIR.forEach(function (l) { LITUR_NAFN[l.nafn.toLowerCase()] = l.id; (l.alias || []).forEach(function (a) { LITUR_NAFN[a.toLowerCase()] = l.id; }); });

  function samstillaAfNativum(ctx) {
    var rot = (ctx && ctx.rot) || (typeof document !== 'undefined' ? document : null);
    if (!rot) return;
    var varaAdur = ST.vara;
    ST.vara = (V().vara) || ST.vara;
    /* the sign type must belong to this product (ST starts as the parking default; on the sameign page
       the first sameign sign is the default, live bug 01.10: no radio checked, summary "einkabilastaedi") */
    var kostir = snidValkostir();
    if (kostir.length && kostir.indexOf(ST.snid) < 0) ST.snid = kostir[0];
    /* bin labels default to tape (handoff section 08: "lím (VHB) sjálfgefið, tunnur eru plast") */
    if (ST.vara === 'flokkunarmerki' && (varaAdur !== 'flokkunarmerki' || !ST.festingSnert)) ST.festing = 'lim';
    var st = checkedNafn('staerd', rot);
    if (st && STAERD_NAFN[st]) ST.staerd = STAERD_NAFN[st];
    var lit = checkedNafn('litur', rot);
    if (lit && LITUR_NAFN[lit.toLowerCase()]) ST.litur = LITUR_NAFN[lit.toLowerCase()];
    /* bin labels have ONE look, "Litur eftir flokki" (owner 08.10): the only variant option is hidden (syna) and the stock comes from FENUR_LITIR */
    if (ST.vara === 'flokkunarmerki') ST.utlit = 'flokkalitur';
    /* Gerð (owner 08.10): "Stakt merki" or "Pakki, öll 6 merkin" (one cart line, six labels in one production file) */
    /* F1 23.10 (P0): the package is told by the Gerð radio's place (Shopify option order: 1 Stakt merki, 2 Pakki), never by its shown
       name: on /en data-nafn is the translated "Pack, all 6 signs" and /pakki/ missed it, so the production file had ONE label */
    var gerdIn = rot.querySelectorAll ? rot.querySelectorAll('[data-lykill="gerd"] input[type=radio]') : [], gerdNr = -1;
    for (var gi = 0; gi < gerdIn.length; gi++) if (gerdIn[gi].checked) gerdNr = gi;
    ST.pakki = ST.vara === 'flokkunarmerki' && gerdNr > 0;
    /* takka-hamur: the number of holes follows the shape of the plate (square: 4, one in each corner; oblong: 2, at the middle of the short sides); the customer picks Goet, Lim or Tappar only */
    if (erTakkar(ctx) && ST.vara !== 'flokkunarmerki') {
      if (ST.festing !== 'lim') ST.festing = formGot();
      else ST.tappar = 'engir';
    }
  }
  /* the handoff lists four schemes per sign (every scheme stays allowed): when the sign type changes
     and the chosen colour is not one of its four, the first of the four is selected on the native radio */
  function veljaSjalfgefinnLit(rot) {
    var T = ST.vara === 'bilastaedaskilti' ? SMHus.BIL_SNID : (ST.vara === 'skilti-fyrir-sameign' ? SMHus.SAM_SNID : null);
    var sn = T && T[ST.snid]; if (!sn || !sn.litir) return;
    var leyfd = sn.litir.map(function (k) { return SMHus.litur(k).id; });
    if (leyfd.indexOf(ST.litur) >= 0) return;
    var vill = SMHus.litur(leyfd[0]).nafn.toLowerCase();
    var inputs = (rot || document).querySelectorAll('[data-lykill="litur"] input');
    for (var i = 0; i < inputs.length; i++) {
      var n = (inputs[i].getAttribute('data-nafn') || inputs[i].value).toLowerCase();
      if (n === vill) { inputs[i].checked = true; inputs[i].dispatchEvent(new Event('change', { bubbles: true })); ST.litur = leyfd[0]; break; }
    }
  }

  /* IS+EN on sameign (main-thread review 02.10: the owner's own handoff design wins over a fixed
     15mm/9mm floor - see sm-husfelag-vel.js skipulag()). English is now just one more line at the
     normal "lines" size, fitted with the same shrink rule as every line, so hiding a size is only
     needed on the rare word/size combination where turning IS+EN on pushes that line past its floor
     (lina_of_long) when it was fine without it - compare ensku on vs off rather than one fixed code. */
  function hfVirkjaStaerdir(rot) {
    if (ST.vara === 'flokkunarmerki') return;
    var inputs = (rot || document).querySelectorAll('[data-lykill="staerd"] input');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var nafn = inp.getAttribute('data-nafn') || inp.value;
      var staerd = STAERD_NAFN[nafn];
      var merki = inp.closest ? (inp.closest('label') || inp.parentElement) : inp.parentElement;
      if (!staerd || !merki) continue;
      var fellurUt = SMHus.leyfdarStaerdir(ST.vara, ST.snid).indexOf(staerd) < 0;
      if (!fellurUt && ST.ensku) {
        var basis = { vara: ST.vara, staerd: staerd, snid: ST.snid, gata: ST.gata, ibud: ST.ibud, linur: ST.linur, ensku: false };
        var an = SMHus.stada(basis).filter(function (c) { return c === 'lina_of_long'; }).length;
        var med = SMHus.stada((function () { var v = {}; for (var k in basis) v[k] = basis[k]; v.ensku = true; return v; })()).filter(function (c) { return c === 'lina_of_long'; }).length;
        fellurUt = med > an;
      }
      merki.style.display = fellurUt ? 'none' : '';
      if (fellurUt && inp.checked) { inp.checked = false; }
    }
  }

  function engineVal() {
    return {
      vara: ST.vara, staerd: ST.staerd, litur: ST.litur, utlit: ST.utlit, snid: ST.snid,
      linur: ST.linur, logo: ST.logo, festing: ST.festing, tappar: ST.tappar, flokkur: ST.flokkur,
      ensku: ST.ensku, gata: ST.gata, ibud: ST.ibud, pakki: ST.pakki,
      magnListi: ST.listi && ST.magnTexti ? parseList(ST.magnTexti) : null
    };
  }
  function parseList(texti) {
    if (!SMMagnListi) return null;
    var snid = { tolur: true, reitir: [{ key: 'ibud', heiti: t('ibudir'), hamark: 20 }] };
    var r = SMMagnListi.lesa(texti, snid);
    return { radir: r.radir.map(function (x) { return x.gildi.ibud; }), villur: r.villur, thjappad: SMMagnListi.thjappa(r.radir.map(function (x) { return x.gildi.ibud; })) };
  }

  /* Adds the "Lógó á skilti" fee line automatically, right after the sign itself lands in the cart -
     main-thread review 02.10: no separate button, two sequential /cart/add.js calls inside the same
     submit. The kit's own senda() (sm-vel-sida.js) only posts one variant per request and does not
     accept a second item, but it DOES dispatch a public 'sm:karfa' DOM event on every successful add
     (see komid()) - listening for that, from this adapter's own script, fires the fee as its own
     request without touching the shared core that every other product on the site also runs through. */
  var logoGjaldASendingu = false;
  /* ONLY the sign's own add counts (detail.lina set by the kit's komid()). sm-magnafslattur.js also dispatches
     'sm:karfa' (detail.magn, no lina) after EVERY /cart/add|change|clear and on page load, so the fee's own
     /cart/add.js made it fire again: a runaway loop that added the fee every ~1 s (fix 08.10: lina required,
     magn events and the fee line itself ignored). */
  if (typeof document !== 'undefined') document.addEventListener('sm:karfa', function (e) {
    var d = (e && e.detail) || {};
    if (!d.lina || typeof d.magn === 'number' || String(d.lina.variant_id) === LOGO_GJALD_VARIANT) return;
    if (!(ST.vara === 'bilastaedaskilti' && ST.snid === 'eigin' && ST.logo) || logoGjaldASendingu) return;
    logoGjaldASendingu = true;
    var fd = new FormData();
    fd.append('id', LOGO_GJALD_VARIANT);
    fd.append('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function () { logoGjaldASendingu = false; }, function () { logoGjaldASendingu = false; });
  });

  /* plugs: 2 per sign on "Göt (2)", 4 on "Göt (4)"; sold as the UNLISTED fee product, one cart line per colour with quantity = plugs x signs
     (the kit's aukalinur posts one entry per plug, each of the sign's quantity, and Shopify merges them); sm-cart.liquid removes or trims
     the fee when its sign line is removed or changed */
  function tapparFjoldi() {
    var v = SMHus.uppsetning(engineVal());
    if (v.tappar === 'engir') return 0;
    return v.festing === 'got4' ? 4 : 2;
  }
  function krTexti(n) { var h = Math.floor(n / 1000), r = n % 1000; return '+' + (h ? h + '.' + ('00' + r).slice(-3) : r) + ' kr.'; }

  var A = {
    gerd: 'svg', skuggi: true, lifandi: true,
    /* aurar (the kit adds it to the price shown): 600 kr per plug; it was returned in krona before, so the bar showed +12 kr instead of +1.200 kr (09.10) */
    aukaverd: function () { return tapparFjoldi() * TAPPAR_VERD * 100; },
    aukalinur: function () {
      var n = tapparFjoldi(), ut = [], i, tp = SMHus.uppsetning(engineVal()).tappar;
      for (i = 0; i < n; i++) ut.push({ id: TAPPAR_VARIANT, properties: { 'Tappar': SMHus.TAPPAR[tp] } });
      return ut;
    },
    /* bin labels (owner 08.10): "Litur eftir flokki" is the default look. The product's first variant is the white-on-black one,
       so on a bare product address (no query string, no ?variant=) the colour-by-category radio is checked before the kit reads the state. */
    upphaf: function (ctx) { CTX = ctx; hladaGogn(); hladaBreytaLista(); if (erTakkar(ctx) && ctx.takkar) takkaBar = takkaSmida(ctx); },
    hlada: function (ctx) { CTX = ctx; hladaGogn(); hladaBreytaLista(); return Promise.resolve(); },
    /* the logo file is the template's skra block (lykill logoskra, cart name 'Logo', lota 7 08.10): the kit sends it (SMSkra), so no skrar hook here */
    teikna: function (ctx) {
      CTX = ctx; samstillaAfNativum(ctx);
      hfVirkjaStaerdir(ctx.rot || document);
      if (ctx.rot && ctx.rot.setAttribute) { if (ST.vara === 'flokkunarmerki' && !ST.pakki) ctx.rot.setAttribute('data-hf-stak', ''); else ctx.rot.removeAttribute('data-hf-stak'); }
      if (takkaBar) takkaBar.uppfaera();
      var svg = SMHus.teikna(engineVal());
      if (ctx.teikning.__hfSvg !== svg) { ctx.teikning.innerHTML = svg; ctx.teikning.__hfSvg = svg; }
    },
    lysing: function () {
      var v = engineVal();
      return u('aria', 'Forskoðun skiltisins');
    },
    /* 14.10 (samraeming): "Daemi" flagan a myndinni (kitid teiknar hana) medan synishornid er teiknad en ekkert hefur verid skrifad */
    /* FB 21.10 (D1): no example is engraved any more (an empty optional field is no line), so the preview is never an example */
    daemi: function () { return false; },
    malband: function () { var s = SMHus.STAERDIR[ST.staerd]; return { b: s.b / 10, h: s.h / 10, eining: 'cm' }; },
    smamynd: function () { return { svg: SMHus.teikna(engineVal()) }; },
    /* 3.3.0: every tile of the colour step is the customer's own sign in that colour (the tile's radio carries the colour name in data-nafn) */
    utlit: {
      teikna: function (s2, ctx, o) {
        if (o && erFlokkFlis(o)) {
          CTX = CTX || ctx; samstillaAfNativum(ctx);
          var vf = engineVal(); vf.flokkur = String(o.gildi || ''); vf.pakki = false; vf.magnListi = null;
          return { svg: SMHus.teikna(vf).replace(/ width="[\d.]+mm" height="[\d.]+mm"/, '') };
        }
        if (!o || o.lykill !== 'litur') return null;
        var rod = (ctx && ctx.rot) || document, el = null, nafn = String(o.gildi || '');
        try { el = rod.querySelector('[data-lykill="litur"] input[value="' + nafn.replace(/"/g, '') + '"]'); } catch (e) { el = null; }
        if (el && el.getAttribute('data-nafn')) nafn = el.getAttribute('data-nafn');
        var id = LITUR_NAFN[String(nafn).toLowerCase()];
        if (!id) return null;
        CTX = CTX || ctx; samstillaAfNativum(ctx);
        var v = engineVal(); v.litur = id;
        return { svg: SMHus.teikna(v).replace(/ width="[\d.]+mm" height="[\d.]+mm"/, '') };
      },
      /* the category cards do not depend on the chosen category (the card's own value is in the kit's key): the same key for all of them */
      lykill: function (s2, ctx, o) { var v = engineVal(); return [v.vara, v.snid, v.staerd, v.festing, v.tappar, v.gata, v.ibud, v.ensku, v.utlit, o && erFlokkFlis(o) ? '' : v.flokkur, o && erFlokkFlis(o) ? '' : v.pakki, (v.linur || []).join('|')].join('~'); }
    },
    veggur: function () {
      var ljosYfirbord = { '902': 1, '917': 1, '906': 1, '990': 1, '991': 1 };
      return (ST.vara === 'flokkunarmerki' ? false : ljosYfirbord[ST.litur]) ? 'dokkur' : 'ljos';
    },
    /* the logo file step shows only on the own-text parking sign with the logo switched on (the fee line follows the sign as before) */
    syna: function (lykill) {
      /* the kit asks before teikna has read the Gerd radios: read them now, else the step stays hidden after Pakki -> Stakt merki (08.10 bug) */
      if (CTX && (lykill === 'stilling' || lykill === 'logoskra')) samstillaAfNativum(CTX);
      if (lykill === 'logoskra') return ST.vara === 'bilastaedaskilti' && ST.snid === 'eigin' && !!ST.logo;
      /* the package has every category: no "Flokkur" step */
      /* an explicit true as well: the kit only changes a step when syna answers true or false, so Pakki -> Stakt merki brings the step back */
      if (lykill === 'stilling' && ST.vara === 'flokkunarmerki') return !ST.pakki;
      /* one size only (9 x 14 cm, owner 08.10): the size step is hidden, the single radio stays checked */
      if (lykill === 'staerd' && ST.vara === 'flokkunarmerki') return false;
      /* one look only (owner 08.10): the "Útlit" step has a single value ("Litur eftir flokki"), so the step and its pill are hidden */
      if (lykill === 'utlit' && ST.vara === 'flokkunarmerki') return false;
      return undefined;
    },
    athuga: function () {
      samstillaAfNativum(CTX);
      var codes = SMHus.stada(engineVal()), ut = [];
      codes.forEach(function (kodi) { ut.push({ kodi: kodi, reitur: 'stilling', stopp: true, texti: t(kodi), hnappur: t('ekki_haegt_i_korfu') }); });
      if (ST.listi) {
        var v = engineVal();
        if (v.magnListi && v.magnListi.villur && v.magnListi.villur.length) {
          ut.push({ kodi: 'listi_villa', reitur: 'stilling', stopp: true, texti: t('tvitekning') });
        }
      }
      return ut;
    },
    eiginleikar: function (s, ctx) {
      samstillaAfNativum(CTX);
      var ut = [];
      ut.push([t('staerd'), ST.staerd.replace('x', ' x ') + ' mm']);
      /* karfan og verkblaðið sýna íslensk heiti ("Svart í hvítt", "Einkabílastæði"), ekki kóða (901, einkabilastaedi); kóðarnir eru áfram í _framleidsla */
      if (ST.vara !== 'flokkunarmerki') ut.push([t('litur'), SMHus.litur(ST.litur).nafn]);
      if (ST.vara === 'bilastaedaskilti') {
        ut.push([t('snidmat'), snidHeiti(ST.snid)]);
        /* P2-G1 21.10 (V01): readable Icelandic in the cart ("Enska: Já", "Logo: Já"), not "IS+EN: ja"; the workshop app reads both */
        if (ST.snid === 'eigin') { ut.push([t('texti'), ST.linur.filter(Boolean).join(' | ')]); if (ST.logo) ut.push(['Logo', 'J\u00e1']); }
        else if (notarGotu()) ut.push([t('gata'), SMHus.uppsetning(engineVal()).gata]);
        if (notarIbud()) ut.push([t('ibud_eitt'), SMHus.uppsetning(engineVal()).ibud]);
        if (ST.ensku && ST.snid !== 'eigin') ut.push(['Enska', 'J\u00e1']);
        if (ST.listi && notarIbud()) {
          var v = engineVal();
          ut.push([t('ibudir'), v.magnListi ? v.magnListi.thjappad : '']);
          ut.push(['_magn', String(v.magnListi ? v.magnListi.radir.length : 1)]);
          ut.push(['_listi', v.magnListi ? JSON.stringify(v.magnListi.radir) : '[]']);
        }
      }
      if (ST.vara === 'skilti-fyrir-sameign') {
        ut.push([t('snidmat'), snidHeiti(ST.snid)]);
        ut.push([t('gata'), SMHus.uppsetning(engineVal()).gata]);
        if (ST.ensku) ut.push(['Enska', 'J\u00e1']);
      }
      if (ST.vara === 'flokkunarmerki') {
        if (ST.pakki) ut.push(['Merki', SMHus.FENUR_PAKKI.join(', ')]);
        else ut.push([t('flokkur'), ST.flokkur]);
        /* P2-G1 21.10 (V02): "Litur: Eftir flokki", not "Litur: Litur eftir flokki" */
        ut.push([t('litur'), 'Eftir flokki']);
      }
      ut.push([t('festing'), SMHus.FESTING[ST.festing] || SMHus.FESTING.got]);
      var tp = SMHus.uppsetning(engineVal()).tappar;
      if (tp !== 'engir') ut.push(['Tappar', SMHus.TAPPAR[tp]]);
      /* 07.10: the kit's notes step (an array from eiginleikar is the WHOLE list, so the note has to be here; same cart name as before) */
      var aths = String(s && s.aths != null ? s.aths : '').replace(/^\s+|\s+$/g, '');
      if (aths) ut.push([(ctx && ctx.eiginleiki('aths')) || 'Athugasemdir með pöntun', aths]);
      return ut;
    },
    framleidsla: function () {
      samstillaAfNativum(CTX);
      var v = engineVal();
      if (ST.vara === 'bilastaedaskilti' && ST.listi && notarIbud() && v.magnListi && v.magnListi.radir.length > 1) {
        return SMHus.hreidra(v, v.magnListi.radir);
      }
      return SMHus.smfram(v);
    },
    skref: {
      stilling: {
        teikna: function (el, s, ctx) { smidaStilling(el, ctx); },
        /* a stopping problem puts the cursor in the text control it is about (own text, the list) before the first choice */
        fokus: function (el, kodi) {
          if (!el) return null;
          if (kodi === 'listi_villa') return el.querySelector('[data-hf-magntexti]');
          return el.querySelector('[data-hf-lina="0"]') || el.querySelector('[data-hf-ibud],[data-hf-gata]') || null;
        },
        gildi: function () { return ST.vara === 'flokkunarmerki' ? (ST.pakki ? u('oll_merkin', '\u00d6ll 6 merkin') : ST.flokkur) : (ST.snid === 'eigin' ? ST.linur.filter(Boolean).join(', ') : snidSyn(ST.snid)); },
        buid: function () { return SMHus.stada(engineVal()).length === 0; }
      }
    }
  };

  /* Takka-hamur (prufa ?view=prufa-husfelag, section stilling "takkar" -> data-takkar on .vs): the fixing and the English line become pills
     on the live preview (ctx.takkar of the kit). They set the same state as the controls of the Stilling step (ST.festing, ST.ensku), so the
     price, cart properties and production file are the same; the step leaves those two controls out. Without data-takkar (the bin labels
     among them) none of this runs. */
  var takkaBar = null;
  function erTakkar(ctx) { return !!(ctx && ctx.rot && ctx.rot.hasAttribute && ctx.rot.hasAttribute('data-takkar')); }
  /* 15.10: bin labels (flokkunarmerki) with data-takkar: the Flokkur cards and the Festing choice (2 holes | 4 holes | tape) become pills under
     the preview; the Stilling step is hidden (data-takka-fel). Same state change as the step's controls (ST.flokkur, ST.festing), so the
     variant, price, cart properties and the production file are the same. The package (Pakki) has every category and no choices: no pills. */
  function flokkaTakkar(ctx) {
    function stakt() { return !ST.pakki; }
    var fl = SMHus.FENUR_FLOKKAR.map(function (f, i) {
      return { k: 'flokkur-' + (i + 1), t: flokkHeiti(f), til: stakt, kv: function () { return ST.flokkur === f; },
        smella: function (kv) { if (!kv) { ST.flokkur = f; ctx.breytt(); } } };
    });
    var fe = [['got', u('got2', '2 g\u00f6t')], ['got4', u('got4', '4 g\u00f6t')], ['lim', u('limrond', 'L\u00edmr\u00f6nd')]].map(function (x) {
      return { k: 'festing-' + x[0], t: x[1], til: stakt, kv: function () { return ST.festing === x[0]; },
        smella: function (kv) { if (!kv) { ST.festing = x[0]; ST.festingSnert = true; ctx.breytt(); } } };
    });
    return ctx.takkar({ fela: ['stilling'], hopar: [{ heiti: u('flokkur', t('flokkur')), pillur: fl }, { heiti: u('festing', t('festing')), pillur: fe }] });
  }
  function takkaSmida(ctx) {
    if (V().vara === 'flokkunarmerki') return flokkaTakkar(ctx);
    function virk() { return ST.vara !== 'flokkunarmerki'; }
    function erGot() { return ST.festing !== 'lim'; }
    function festa(f, tp) { ST.festing = f === 'lim' ? 'lim' : formGot(); ST.tappar = f === 'lim' ? 'engir' : tp; ST.festingSnert = true; ctx.breytt(); }
    var fest = [
      { k: 'festing-got', t: 'G\u00f6t', til: virk, kv: function () { return erGot() && ST.tappar === 'engir'; }, smella: function (kv) { if (!kv) festa('got', 'engir'); } },
      { k: 'festing-lim', t: 'L\u00edm', til: virk, kv: function () { return !erGot(); }, smella: function (kv) { if (!kv) festa('lim', 'engir'); } },
      { k: 'festing-tappar', t: 'Tappar', til: virk, kv: function () { return erGot() && ST.tappar !== 'engir'; }, smella: function (kv) { if (!kv) festa('got', ST.tappar !== 'engir' ? ST.tappar : 'silfur'); } }
    ];
    /* plugs: two colour dots, only while Tappar is chosen (price as before: 600 kr per plug, the holes give the number) */
    var tp = [['svartir', 'Svartir tappar', 'svart'], ['silfur', 'Silfur tappar', 'silfur']].map(function (x) {
      return { k: 'tappar-' + x[0], punktur: x[2], t: x[1], til: function () { return virk() && erGot() && ST.tappar !== 'engir'; }, kv: function () { return ST.tappar === x[0]; },
        smella: function (kv) { if (!kv) { ST.tappar = x[0]; ctx.breytt(); } } };
    });
    var ens = [{ k: 'ensku', t: 'Enska l\u00edka', til: function () { return virk() && ST.snid !== 'eigin'; }, kv: function () { return !!ST.ensku; },
      smella: function (kv) { ST.ensku = !kv; ctx.breytt(); } }];
    return ctx.takkar({ fela: [], hopar: [{ heiti: 'Texti', pillur: ens }, { heiti: 'Festing', pillur: fest }, { heiti: 'Tappar', punktar: true, pillur: tp }] });
  }

  /* official category names are upper case in the data (MATARLEIFAR): shown as Matarleifar, Blandaður úrgangur */
  /* the kit names a tile's step by the step key ('stilling'): on the bin label page the only picture tiles in that step are the category cards */
  function erFlokkFlis(o) { return !!o && (o.lykill === 'flokkur' || (o.lykill === 'stilling' && ST.vara === 'flokkunarmerki')); }
  function flokkHeiti(f) { var x = String(f || '').toLowerCase(); return x.charAt(0).toUpperCase() + x.slice(1); }

  function formGot() { var S = SMHus.STAERDIR[ST.staerd]; return S && S.b === S.h ? 'got4' : 'got'; }
  function snidValkostir() {
    if (ST.vara === 'bilastaedaskilti') return Object.keys(SMHus.BIL_SNID);
    if (ST.vara === 'skilti-fyrir-sameign') return Object.keys(SMHus.SAM_SNID);
    return [];
  }
  function snidGogn0(id) { return (ST.vara === 'bilastaedaskilti' ? SMHus.BIL_SNID : SMHus.SAM_SNID)[id] || null; }
  function snidGogn() { return (ST.vara === 'bilastaedaskilti' ? SMHus.BIL_SNID : SMHus.SAM_SNID)[ST.snid] || null; }
  function notarIbud() { var g = snidGogn(); return !!(g && ((g.addr && g.addr.indexOf('{ibud}') >= 0) || (g.tag && g.tag.indexOf('{ibud}') >= 0))); }
  function notarGotu() { var g = snidGogn(); return !!(g && g.addr && g.addr.indexOf('{heimilisfang}') >= 0); }
  function snidHeiti(id) {
    var T = ST.vara === 'bilastaedaskilti' ? SMHus.BIL_SNID : SMHus.SAM_SNID, g = T[id];
    if (!g || !g.heiti) return t('texti');
    /* a sign whose own line is fixed text (tow-away) shows that line after the name, so two choices never read the same */
    return (g.heiti + (g.tag && g.addr && g.addr.indexOf('{') < 0 ? ', ' + g.addr : '')).replace(' - ', ', ');
  }

  /* FL 21.10: sniðmátsheiti SEM SÉST (flísar og skrefagildi) utan íslensku úr ui_snid ("einkabilastaedi=Private parking|..."); karfan notar snidHeiti (íslenskt). */
  var SNID_EN = null;
  function snidSyn(id) {
    if (!SNID_EN) { SNID_EN = {}; String(u('snid', '')).split('|').forEach(function (p) { var i = p.indexOf('='); if (i > 0) SNID_EN[p.slice(0, i).replace(/^\s+|\s+$/g, '')] = p.slice(i + 1).replace(/^\s+|\s+$/g, ''); }); }
    return SNID_EN[id] || snidHeiti(id);
  }

  /* Stilling step (lota 7, 08.10): built from the kit units (ctx.html.kostir for sign type and fixing, reitur, rofi, velja) and set with ctx.html.setja,
     which keeps the focused control focused. The markup carries no typed text (values are set after it is drawn), so it changes only with the
     structure. The adapter keeps its state and listens by delegation; the names and data-hf-* are the ones the page always had. */
  function smidaStilling(el, ctx) {
    if (!el.__hfBuilt) {
      el.__hfBuilt = true;
      el.addEventListener('input', function (e) { hfInntak(e.target, ctx); });
      el.addEventListener('change', function (e) { hfBreyting(e.target, ctx); });
    }
    teiknaUI(el, ctx);
  }
  /* Takn eins og broskallar (emoji) eru ekki grafin: tekin ur um leid og skrifad er, med stuttri skyringu (sama adferd og adrar velar) */
  var TAKN_RE, TAKN_ATH = 'T\u00e1kn eins og broskallar eru ekki grafin.';
  try { TAKN_RE = new RegExp('[\\p{Extended_Pictographic}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{E0020}-\\u{E007F}\\u20E3\\uFE0E\\uFE0F\\u200D]', 'gu'); }
  catch (e) { TAKN_RE = /[\uD83C-\uDBFF][\uDC00-\uDFFF]|[\u2190-\u21FF\u2300-\u23FF\u2460-\u24FF\u25A0-\u27BF\u2900-\u29FF\u2B00-\u2BFF\u3030\u303D\u3297\u3299\u00A9\u00AE\u203C\u2049\u2122\u2139\u20E3\uFE0E\uFE0F\u200D]/g; }
  function hreinsaTakn(inp, haldaLinuskilum) {
    var v = inp.value || '', n = v.replace(TAKN_RE, ''), tok = n !== v;
    /* broskall milli tveggja orda skilur eftir tvo bil: eitt er haldid */
    if (tok) n = n.replace(/ {2,}/g, ' ');
    if (!haldaLinuskilum) n = n.replace(/[\r\n\t]+/g, ' ');
    if (n === v) return false;
    var pos = typeof inp.selectionStart === 'number' ? inp.selectionStart : v.length, ny = pos;
    try { ny = Math.min(n.length, v.slice(0, pos).replace(TAKN_RE, '').replace(/ {2,}/g, ' ').length); } catch (e) {}
    inp.value = n;
    try { if (document.activeElement === inp) inp.setSelectionRange(ny, ny); } catch (e2) {}
    return tok;
  }
  function hfInntak(inp, ctx) {
    if (!inp || !inp.hasAttribute) return;
    if (inp.hasAttribute('data-hf-lina') || inp.hasAttribute('data-hf-gata') || inp.hasAttribute('data-hf-ibud') || inp.hasAttribute('data-hf-magntexti')) {
      if (hreinsaTakn(inp, inp.hasAttribute('data-hf-magntexti')) && ctx.tilkynna) ctx.tilkynna(u('takn_ath', TAKN_ATH), true); /* F1 23.10 (T8): shop language */
    }
    if (inp.hasAttribute('data-hf-lina')) ST.linur[Number(inp.getAttribute('data-hf-lina'))] = inp.value;
    else if (inp.hasAttribute('data-hf-gata')) ST.gata = inp.value;
    else if (inp.hasAttribute('data-hf-ibud')) ST.ibud = inp.value;
    else if (inp.hasAttribute('data-hf-magntexti')) ST.magnTexti = inp.value;
    else return;
    ctx.breytt();
  }
  function hfBreyting(inp, ctx) {
    if (!inp || !inp.hasAttribute) return;
    if (inp.name === 'hf-snid') { if (inp.checked) { ST.snid = inp.value; veljaSjalfgefinnLit(ctx.rot || document); ctx.breytt(); } }
    else if (inp.name === 'hf-festing') { if (inp.checked) { ST.festing = inp.value; ST.festingSnert = true; ctx.breytt(); } }
    else if (inp.name === 'hf-tappar') { if (inp.checked) { ST.tappar = inp.value; ctx.breytt(); } }
    else if (inp.hasAttribute('data-hf-logo')) { ST.logo = inp.checked; if (!inp.checked) ST.logoSkra = null; ctx.breytt(); }
    else if (inp.hasAttribute('data-hf-listi')) { ST.listi = inp.checked; ctx.breytt(); }
    else if (inp.hasAttribute('data-hf-ensku')) { ST.ensku = inp.checked; ctx.breytt(); }
    else if (inp.name === 'hf-flokkur') { if (inp.checked) { ST.flokkur = inp.value; ctx.breytt(); } }
    else if (inp.hasAttribute('data-hf-flokkur')) { ST.flokkur = inp.value; ctx.breytt(); }
  }
  /* "Ibud (t.d. Ibud 101)" -> "Ibud": the example is the placeholder, the label keeps the name of the field */
  function styttaHeiti(x) { return String(x).replace(/\s*\((?:t\.d\.|e\.g\.)[^)]*\)\s*$/, '') || String(x); }
  function hfHeiti(x) { return '<p class="vs-reitur-heiti">' + esc(x) + '</p>'; }

  function teiknaUI(el, ctx) {
    var id = 'vs-' + ctx.id + '-hf', h = '', fl = [], gildi = [];
    if (ST.vara === 'bilastaedaskilti' || ST.vara === 'skilti-fyrir-sameign') {
      var val = snidValkostir();
      /* a group with one choice is not shown (owner 07.10) */
      if (val.length > 1) {
        h += hfHeiti(u('snidmat', t('snidmat'))) + ctx.html.kostir({ nafn: 'hf-snid', birting: 'pillur', dalkar: 2, merki: u('snidmat', t('snidmat')),
          kostir: val.map(function (k) { var g = snidGogn0(k); return { gildi: k, heiti: g && g.heiti ? snidSyn(k) : u('texti', snidHeiti(k)), valid: ST.snid === k }; }) });
      }
      if (ST.snid === 'eigin') {
        h += ctx.html.reitir([
          { id: id + '-lina0', heiti: u('texti', t('texti')) + ' 1', hamark: 20, teljari: false, villa: false, skylda: true, fokus: 'hf-lina-0', attr: { autocomplete: 'off' }, gogn: { 'hf-lina': '0' } },
          { id: id + '-lina1', heiti: u('texti', t('texti')) + ' 2', valfrjalst: true, hamark: 20, teljari: false, villa: false, fokus: 'hf-lina-1', attr: { autocomplete: 'off' }, gogn: { 'hf-lina': '1' } }
        ]);
        gildi.push(['[data-hf-lina="0"]', ST.linur[0] || ''], ['[data-hf-lina="1"]', ST.linur[1] || '']);
        h += ctx.html.rofi({ id: id + '-logo', heiti: t('logo_valkostur'), valid: ST.logo, fokus: 'hf-logo', gogn: { 'hf-logo': true } });
        if (ST.logo) h += ctx.html.bod(t('logo_gjald_hjalp'), 'hjalp');
      } else {
        /* FB 21.10 (D1): the example is only the placeholder; an empty field is no line on the sign and no cart property */
        if (notarIbud()) {
          fl.push({ id: id + '-ibud', heiti: u('ibud', styttaHeiti(t('ibud_eitt'))), valfrjalst: true, hamark: 24, teljari: false, villa: false, synishorn: u('ibud_daemi', 't.d. ' + SMHus.SJALFGEFID.ibud),
            fokus: 'hf-ibud', attr: { autocomplete: 'off' }, gogn: { 'hf-ibud': true } });
          gildi.push(['[data-hf-ibud]', ST.ibud || '']);
        }
        if (notarGotu()) {
          fl.push({ id: id + '-gata', heiti: u('gata', styttaHeiti(t('gata'))), valfrjalst: true, hamark: 30, teljari: false, villa: false, synishorn: u('gata_daemi', 't.d. Laugavegur 6'),
            fokus: 'hf-gata', attr: { autocomplete: 'off' }, gogn: { 'hf-gata': true } });
          gildi.push(['[data-hf-gata]', ST.gata || '']);
        }
        if (fl.length) h += ctx.html.reitir(fl);
        if (!erTakkar(ctx)) h += ctx.html.rofi({ id: id + '-ensku', heiti: t('ensku_valkostur'), valid: ST.ensku, fokus: 'hf-ensku', gogn: { 'hf-ensku': true } });
        if (ST.vara === 'bilastaedaskilti' && notarIbud()) {
          var lt = t('listi_hjalp'), q = lt.indexOf('? ');
          h += ctx.html.rofi({ id: id + '-listi', heiti: q > 0 ? lt.slice(0, q + 1) : lt, undir: q > 0 ? lt.slice(q + 2) : '', valid: ST.listi, fokus: 'hf-listi', gogn: { 'hf-listi': true } });
          if (ST.listi) {
            h += ctx.html.reitur({ id: id + '-magntexti', heiti: u('ibudir', t('ibudir')), gerd: 'svaedi', linur: 3, villa: false, synishorn: '101-105, 201-205', fokus: 'hf-magntexti',
              gogn: { 'hf-magntexti': true } });
            gildi.push(['[data-hf-magntexti]', ST.magnTexti || '']);
          }
        }
      }
    } else if (ST.vara === 'flokkunarmerki') {
      /* the category is picture cards: every card is that label drawn in its own colour (utlit.teikna below), the name under it */
      h += ctx.html.kostir({ nafn: 'hf-flokkur', birting: 'utlit', lykill: 'flokkur', klasi: 'vs-husfelag-flokkur', merki: u('flokkur', t('flokkur')), dalkar: 3,
        kostir: SMHus.FENUR_FLOKKAR.map(function (f) { return { gildi: f, heiti: flokkHeiti(f), valid: ST.flokkur === f }; }) });
    }
    if (!erTakkar(ctx)) h += hfHeiti(u('festing', t('festing'))) + ctx.html.kostir({ nafn: 'hf-festing', birting: 'pillur', dalkar: 3, merki: u('festing', t('festing')), kostir: [
      { gildi: 'got', heiti: u('got2', '2 g\u00f6t'), valid: ST.festing === 'got' },
      { gildi: 'got4', heiti: u('got4', '4 g\u00f6t'), valid: ST.festing === 'got4' },
      { gildi: 'lim', heiti: u('limrond', 'L\u00edmr\u00f6nd'), valid: ST.festing === 'lim' }] });
    /* plugs (black / silver): built, hidden until the owner has decided the price (SMHus.TAPPAR_VIRKT) */
    if (SMHus.tapparVirkt() && ST.vara !== 'flokkunarmerki' && ST.festing !== 'lim' && !erTakkar(ctx)) {
      var fj = ST.festing === 'got4' ? 4 : 2, und = krTexti(fj * TAPPAR_VERD);
      h += hfHeiti(u('tappar', 'Tappar')) + ctx.html.kostir({ nafn: 'hf-tappar', birting: 'pillur', dalkar: 3, merki: u('tappar', 'Tappar'), kostir: [
        { gildi: 'engir', heiti: u('engir', 'Engir'), valid: ST.tappar === 'engir' },
        { gildi: 'svartir', heiti: u('svartir', 'Svartir'), undir: und, valid: ST.tappar === 'svartir' },
        { gildi: 'silfur', heiti: u('silfur', 'Silfur'), undir: und, valid: ST.tappar === 'silfur' }] });
    }
    var nytt = ctx.html.setja(el, h);
    /* the category cards are new markup: draw them (the kit draws tiles of its own steps by itself) */
    if (nytt && ST.vara === 'flokkunarmerki' && ctx.flisar) setTimeout(function () { ctx.flisar(); }, 0);
    /* typed text is set after the markup: only on a fresh draw, or in a control the customer is not typing in */
    gildi.forEach(function (x) {
      var e = el.querySelector(x[0]);
      if (e && e.value !== x[1] && (nytt || document.activeElement !== e)) e.value = x[1];
    });
  }

  A.innri = { ST: ST, engineVal: engineVal, parseList: parseList };

  if (typeof window !== 'undefined') {
    if (window.SMVelSida) window.SMVelSida.skra('husfelag', A);
    else (window.SMVelSidaBid = window.SMVelSidaBid || []).push(['husfelag', A]);
    window.SMHusfelagAdapter = A;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = A;
})();
